import { Box, Dialog } from "@material-ui/core";
import React, { useCallback, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import "./HomePage.css";
import { types } from "../../components/Auth/reducer";
import FSLoader from "../../components/Loaders/FSLoader";
import InstaFeed from "../../components/instaFeed/instaFeed";
import Loyalty from "../../components/loyalty/loyalty";
import LoyaltyProgress from "../../components/loyalty/loyaltyProgress";
import UserBasketList from "../../components/Basket/UserBasketList/UserBasketList";
import { useAuth } from "../../components/Auth/useAuth";
import sdk from "../../sdk/sdk";

function HomePage() {
  const [auth, { isRoleClient }] = useAuth();
  const [dialogOpen, isDialogOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loyaltyRewardData, setLoyaltyRewardData] = useState(null);
  const [loyaltyRewardRatingData, setLoyaltyRewardRatingData] = useState(null);
  const [minThreshold, setMinThreshold] = useState(undefined);
  const [maxThreshold, setMaxThreshold] = useState(undefined);
  const [amountThresholds, setAmountThresholds] = useState(undefined);
  const [spendingAmount, setSpendingAmount] = useState(0);

  const [isCartCreating, setCartCreationProcessing] = React.useState(false);
  const clientOfOperator = auth?.user?.client_profile;

  const dispatch = useDispatch();
  const userLoyaltyReward = auth?.user?.data.loyalty_reward;
  const userName = auth?.user?.data.name;

  const isMounted = React.useRef(true);
  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const toggleDialog = () => {
    isDialogOpen(true);
  };

  const checkUpdatedDateIsOneHourAgo = (targetDate) => {
    if (!targetDate) return true;
    const diffMs = Date.now() - new Date(targetDate).getTime();
    return diffMs > 60 * 60 * 1000;
  };

  const computeThresholds = useCallback((amount, data) => {
    if (!data?.length) return;
    let min = data[0],
      max = data[data.length - 1];

    for (let i = 0; i < data.length; i++) {
      const t = data[i].amount;
      if (t <= amount) min = data[i];
      else {
        max = data[i];
        break;
      }
    }

    setMinThreshold(min);
    setMaxThreshold(max);
    setAmountThresholds(data.map((el) => el.amount));
  }, []);

  const fetchLoyaltyData = useCallback(async () => {
    const data = await sdk.users.loyalty(
      new Date().getFullYear(),
      clientOfOperator?.id || auth?.user?.id,
    );

    if (!isMounted.current) return;
    const payload = data?.payload;

    const isLoyaltyPresent = payload && payload?.loyalty_reward_rating?.length;
    if (isLoyaltyPresent) {
      setSpendingAmount(payload?.spending_amount);
      setLoyaltyRewardData(payload?.proHTML);
      setLoyaltyRewardRatingData(payload?.loyalty_reward_rating);
      computeThresholds(
        payload?.spending_amount,
        payload?.loyalty_reward_rating,
      );
      dispatch({
        type: types.ADD_LOYALTY_REWARD,
        payload: { ...payload, updated_at: new Date() },
      });
    }

    setLoading(false);
  }, [dispatch, computeThresholds, auth, clientOfOperator?.id]);

  useEffect(() => {
    const shouldFetch =
      !userLoyaltyReward ||
      checkUpdatedDateIsOneHourAgo(userLoyaltyReward.updated_at);

    if (shouldFetch) {
      fetchLoyaltyData();
    } else {
      const data = userLoyaltyReward;
      setSpendingAmount(data.spending_amount);
      setLoyaltyRewardData(data.proHTML);
      setLoyaltyRewardRatingData(data.loyalty_reward_rating);
      computeThresholds(data.spending_amount, data.loyalty_reward_rating);
      setLoading(false);
    }
  }, [userLoyaltyReward, fetchLoyaltyData, computeThresholds]);

  function renderNewsPanel() {
    return (
      <React.Fragment>
        <div>
          <span className="left-panel__title">Actualités</span>
          <div className="left-panel__separator"></div>
          <p
            className="left-panel__text"
            dangerouslySetInnerHTML={{ __html: loyaltyRewardData?.description }}
          />
        </div>
      </React.Fragment>
    );
  }

  function renderClientLeftPanel() {
    function renderLoyaltyDialog() {
      return (
        <React.Fragment>
          <Dialog
            open={dialogOpen}
            onClose={() => isDialogOpen(false)}
            PaperProps={{
              style: {
                maxWidth: "80vw",
              },
            }}
          >
            <Box p={3}>
              <Loyalty
                closeLoyalty={isDialogOpen}
                rewardRating={loyaltyRewardRatingData}
              />
            </Box>
          </Dialog>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <div className="left-panel">
          <LoyaltyProgress
            spendingAmount={spendingAmount}
            minThreshold={minThreshold}
            maxThreshold={maxThreshold}
            amountThresholds={amountThresholds}
            toggleDialog={toggleDialog}
          />
          {renderLoyaltyDialog()}
        </div>
        {renderNewsPanel()}
      </React.Fragment>
    );
  }

  function renderOperatorLeftPanel() {
    return (
      <React.Fragment>
        {renderNewsPanel()}
        <UserBasketList disabledBtn={isCartCreating} />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <Container fluid className="home-page">
        <Row className="justify-content-md-center m-5">
          <div className="home-title">
            {"Bonjour, "}
            {isRoleClient() || !clientOfOperator
              ? userName
              : clientOfOperator.name}
          </div>
        </Row>
        {loading && <FSLoader />}
        {!loading && (
          <Row xs={1} md={2} className="flex-column flex-lg-row ">
            <Col md={12} lg={6} className="mb-4">
              {isRoleClient() || clientOfOperator?.id
                ? renderClientLeftPanel()
                : renderOperatorLeftPanel()}
            </Col>
            <Col md={12} lg={6}>
              <InstaFeed />
            </Col>
          </Row>
        )}
      </Container>
    </React.Fragment>
  );
}

export default HomePage;
